
var Vue = require('vue');
var $ = require('js/sw-jquery/sw-jquery');

var REPRINT_REASON_CATEGORY_ID = "data-sw-reprint-category-id";
var REPRINT_REASON_NAME = "data-sw-reprint-reason";

module.exports = function ($fragment) {
  $fragment.swFindWithSelf("[data-sw-tray-crash]").each(function () {
    var $reprintReasons = $("[data-sw-reprint-reasons]");
    var optionsData = {};
    $("[data-sw-reprint-reasons-cateogories] option").each(function(){
      optionsData[$(this).val()] = [];
    });

    $reprintReasons.each(function(){
      var reprintCategoryId = $(this).attr(REPRINT_REASON_CATEGORY_ID);
      var reprintReasonText = $(this).attr(REPRINT_REASON_NAME);
      var reprintReasonVal = $(this).val();
      if(reprintReasonText != "default"){
        optionsData[reprintCategoryId].push({text:reprintReasonText , value: reprintReasonVal});
      }
    });
    new Vue({
      el: this,
      data: {
        reprintCategories: '',
        optionsData: optionsData
      },
      computed: {
        options: function () {
          var selectedCategory = this.reprintCategories;
          options = this.optionsData[selectedCategory];
          return options
        }
      }
    });
  });
};

